export default {
  "gemExchangeMallAdmin.thead.index": "#NO",
  "gemExchangeMallAdmin.thead.sortWeight": "权重",
  "gemExchangeMallAdmin.thead.gemMallId": "兑换ID",
  "gemExchangeMallAdmin.thead.goodsId": "商品ID",
  "gemExchangeMallAdmin.thead.gem_goods_tags": "标签",
  "gemExchangeMallAdmin.thead.goodsName": "商品名称",
  "gemExchangeMallAdmin.thead.goodsImg": "商品图片",
  "gemExchangeMallAdmin.thead.gem_goods_type": "商品类型",
  "gemExchangeMallAdmin.thead.exchangeGemQuantity": "消耗宝石数",
  "gemExchangeMallAdmin.thead.exchangeGoodsQuantity": "兑换商品数",
  "gemExchangeMallAdmin.thead.exchangeLimitPerUser": "用户兑换次数限制",
  "gemExchangeMallAdmin.thead.stocks": "库存",
  "gemExchangeMallAdmin.thead.tips": "兑换提示",
  "gemExchangeMallAdmin.thead.tipsPlaceholder": "No returns after redemption",
  "gemExchangeMallAdmin.thead.remarkTips": "商品备注",
  "gemExchangeMallAdmin.thead.remarkTipsPlaceholder": "Yellow clothes, size XL",
  "gemExchangeMallAdmin.thead.activeState": "状态",
  "gemExchangeMallAdmin.thead.createdAt": "创建时间",
  "gemExchangeMallAdmin.thead.updatedAt": "更新新时间",

  "gemExchangeMallAdmin.add": "新增",
  "gemExchangeMallAdmin.edit": "编辑",
  "gemExchangeMallAdmin.details": "详情",
  "gemExchangeMallAdmin.delete": "删除",
  "gemExchangeMallAdmin.thead.action": "操作",
};
